import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  animateBackground: ".animation--section-introduction-background",
  sectionBlockItems: ".animation--section-introduction > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(
    node,
    [selectors.animateBackground, selectors.sectionBlockItems],
    3
  );

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
